export default "/images/pensam.png?d884f58d632106a05aa39eb84c7504a8";